<template lang="pug">

  transition(name="datepicker")
    div.p-datepicker(v-click-outside="hideDatePicker", v-bind:style="{ minWidth: minWidth }")
      p-text-field.p-datepicker__textfield(
        v-model="displayValue",
        :label="label ? label : ' '",
        :name="name",
        type="text",
        autocomplete="off",
        :required="$attrs.hasOwnProperty('required')",
        :loading="loading",
        :disabled="disabled",
        v-mask="'##/##/####'",
        :error="error"
        :readonly="readonly"
      )

        template(slot="icon")
          PButton(:size="buttonSize" color="primary" @click="openDatePicker" :disabled="disabled")
            span.icon-ptt-icons-calendario.color-primary-contrast(v-uiv-tooltip="'Mostrar calendário'" :disabled="disabled")

      transition(name="bounce")
        .v-calendar-wrapper(v-if="showDatePicker")
          v-date-picker(
            v-model="stateFormated",
            locale="pt-PT",
            :mode="mode"
            is-inline,
            :minDate="minDate"
            :maxDate="maxDate"
          )

</template>

<script>
import PTextField from 'src/common/inputs/PTextField.vue'
import PButton from 'src/common/buttons/PButton.vue'

import moment from 'moment'

import { ptBR } from 'vuejs-datepicker/dist/locale'
import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import { mask } from 'vue-the-mask'

export default {
  name: 'PDatePicker',
  mixins: [handlerUseStateVmodel()],
  directives: { mask },
  components: {
    PButton,
    PTextField
  },
  props: {
    name: { type: String, required: true },
    format: { type: String, 'default': 'DD/MM/YYYY' },
    loading: Boolean,
    disabled: Boolean,
    label: String,
    error: String,
    range: { type: Boolean, default: false },
    minDate: {type: Date},
    maxDate: {type: Date},
    buttonSize: {type: String, default: 'sm'}
  },
  watch: {
    state () {
      this.calculateInputValue()
    },
    value () {
      this.calculateInputValue()
    }
  },
  data () {
    return {
      ptBR: ptBR,
      showDatePicker: false,
      inputValue: '',
      minWidth: this.range ? '175px' : '120px'
    }
  },
  mounted () {
    // Get initial value
    this.calculateInputValue()
  },
  methods: {
    openDatePicker () { this.showDatePicker = !this.showDatePicker },
    hideDatePicker () { this.showDatePicker = false },
    setInputValueInterval (start, end) {
      const startFormated = moment(start).format(this.format)
      const endFormated = moment(end).format(this.format)
      this.inputValue = `${startFormated} - ${endFormated}`
    },
    calculateInputValue () {
      if (this.mode === 'single') {
        this.inputValue = moment(this.stateFormated)

        if (!this.inputValue.isValid()) {
          this.inputValue = ''
        } else {
          this.inputValue = this.inputValue.format(this.format)
        }
      } else if (this.mode === 'range') {
        this.setInputValueInterval(this.stateFormated.start, this.stateFormated.end)
      }
    }
  },
  computed: {
    displayValue: {
      get () { return this.inputValue },
      set (value) {
        if (this.mode === 'single') {
          if (value === '') {
            this.inputValue = ''
            this.state = null
          }
          value = moment(value, this.format, true)
          if (value.isValid()) {
            this.stateFormated = value.toDate()
          }
        }
      }
    },
    stateFormated: {
      get () { return this.state },
      set (value) {
        if (value !== this.state) {
          this.hideDatePicker()
          this.state = value

          if (this.mode === 'single') {
            this.inputValue = moment(value, this.format, true)
          } else if (this.mode === 'range') {
            this.setInputValueInterval(value.start, value.end)
          }
        }
      }
    },
    mode () { return this.range ? 'range' : 'single' },
    readonly () { return this.range }
  }
}
</script>

<style>
.p-datepicker {
  display: inline-flex;
  align-items: flex-end;
  width: 100%;
  animation: slide-down .2s ease-out;
}

.p-datepicker__input--original {
  border: none;
  width: 100%;
  text-align: center;
  background-color: transparent;
  font-size: 20px;
  cursor: pointer;
}

.p-datepicker__wrapper {
  position: absolute !important;
  z-index: 2000 !important;
  margin-top: 50px;
  align-self: baseline;
}
/* ## V CALENDAR ################ */
.v-calendar-wrapper {
  position: absolute !important;
  z-index: 2000 !important;
  margin-top: 50px;
  align-self: baseline;
}
.vc-container {
  font-family: "Rubik", sans-serif !important;
}
/* faz o dia ficar quadrado e com a nossa cor */
.vc-rounded-full {
  border-radius: 0px !important;
}
.vc-bg-blue-600 {
  background-color: var(--color-primary) !important;
}
/* deixa o box com visual flat */
.vc-rounded-lg {
  border-radius: 0 !important;
}
</style>
